export const optimizeImage = (url: string, width: number, quality = 75) => {
  // Add your image optimization logic here
  // Example using a CDN like Cloudinary or Imgix
  return `${url}?w=${width}&q=${quality}&auto=format`;
};

export const getImageDimensions = async (src: string): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = src;
  });
}; 